import axios from 'axios';
import config from '../config.json';
var id = "5cf319357f146a000fd4bad7"
    //var id = '5b227342ed5267000526185d';

export default {

    getAllActions() {
        return axios.get(config.server + '/events/')
    },
    getMainAction() {
        return axios.get(config.server + '/events/' + id);
    },
    getIssuesAction() {
        return axios.get(config.server + `/issues?event=${id}`);
    },
    getPostsAction() {
        return axios.get(config.server + `/posts?event=${id}&limit=100`);
    },
    getTeamsAction() {
        return axios.get(config.server + `/events/${id}/participants?limit=10000`);
    },

    getTeamGPS(idteam) {
        return axios.get(config.server + `/gps?team=${idteam}&event=${id}`);
    },

    getTeamAction(idteam, data) {
        if (data == undefined) {
            return axios.get(config.server + `/events/participants?team=${idteam}&event=${id}`);
        }

        if (data == 'posts') {
            return axios.get(config.server + `/posts?owner=${idteam}`);
        }

        if (data == 'media') {
            return axios.get(config.server + `/posts?owner=${idteam}&media=true`);
        }

        if (data == 'issues') {
            return axios.get(config.server + `/issues?team=${idteam}`);
        }
    },
    getGpsAction() {
        return axios.get(config.server + `/gps?event=${id}&limit=0`)
    },
    getMediaAction() {
        return axios.get(config.server + `/events/${id}/media`)
    },
    getStatusAction() {
        return axios.get(config.server + `/events/${id}/stats`)
    }
}